<template>
  <v-container class="container--max ch-section" tag="section" v-if="featuredPost">
    <v-row>
      <v-col cols="12">
        <div class="ch-section__titleX accent--text mt-3">
          <!-- Tory Diary -->
          <v-btn text color="accent" href="/torydiary">Tory Diary <v-icon small right>mdi-chevron-right</v-icon></v-btn>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <v-card class="ch-post ch-post--featured" :href="featuredPost.link" flat>
          <v-img :src="featuredPost.image ? featuredPost.image : featuredPost.author_image" :aspect-ratio="16/9" cover class="grey lighten-4"></v-img>
          <v-card-title v-html="featuredPost.title" class="ch-post__title font-weight-bold text--caslon"></v-card-title>
          <v-card-subtitle v-if="showCategory(featuredPost)" class="primary--text py-1" v-html="featuredPost.author_name"></v-card-subtitle>
          <v-card-subtitle v-else class="primary--text py-1" v-html="featuredPost.category.name"></v-card-subtitle>
          <v-card-text v-html="featuredPost.excerpt"></v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" class="mt-n4">
        <v-card class="mb-2 ch-post ch-post--secondary" v-for="(item, i) in otherItems" :key="i" :href="item.link" flat>
          <v-card-title v-html="item.title" class="ch-post__title ch-post__subtitle text--caslon"></v-card-title>
          <v-card-subtitle v-if="showCategory(item)" class="primary--text py-1" v-html="item.category.name"></v-card-subtitle>
          <v-card-subtitle v-else class="primary--text pt-1" v-html="item.author_name"></v-card-subtitle>
          <!-- <v-card-text v-html="item.excerpt"></v-card-text> -->
        </v-card>
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
  export default {
    name: 'HomeToryDiary',

    mixins: [
      require('./section.js').default
    ],

    methods: {
      getToryDiaryPosts() {
        this.$axios.get('/wp-json/wp/v2/posts?exclude=' + this.excludedIds 
          + '&categories=' + this.categories 
          + '&filter[orderby]=date&order=desc&per_page=5')
        .then(response => {
          this.items = response.data
        })
      },
      showCategory(item) {
        return item.category.name == 'Interviews'
      }
    },

    mounted() {
      this.getToryDiaryPosts()
    }
  }
</script>
